import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";

const FechaHora=()=>{
  const [fecha, setFecha]=useState('');
  const [hora, setHora]=useState('');
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  useEffect(()=>{
    const actualizarFechaHora=()=>{
      const ahora = new Date();
      const opcionesFecha={
        weekday:'long',
        day:'numeric',
        month:'long'
      }
      const fechaFormateada=ahora.toLocaleDateString('es-ES', opcionesFecha);
      const horaFormateada=ahora.toLocaleTimeString('es-ES',{
        hour:'2-digit',
        minute:'2-digit',
        hour12:false
      });
      setFecha(fechaFormateada);
      setHora(horaFormateada);
    };

    actualizarFechaHora();

    const ahora = new Date();
    const milisegundosHastaProximoMinuto=(60-ahora.getSeconds())*1000;

    let intervaloId;
    const timeoutId = setTimeout(()=>{
      actualizarFechaHora();
      intervaloId = setInterval(actualizarFechaHora, 60000);
    }, milisegundosHastaProximoMinuto);

    return ()=>{
      clearTimeout(timeoutId);
      clearInterval(intervaloId);
    };
  },[]);

  return(
    <Box>
      {isSmUp && (
        <Typography sx={{fontWeight:'bold', textAlign:'end'}}>{fecha}</Typography>
      )}
      <Typography variant="h4" sx={{fontWeight:'bold', textAlign:'end'}}>{hora}</Typography>
    </Box>
  );
};

export default FechaHora;